import { BEDRIVE_CONFIG } from './bedrive-config';
const ɵ0 = BEDRIVE_CONFIG;
export class AppModule {
}
export { ɵ0 };
